import React from 'react';
import { Button, Grid, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';

const RequestAccessMessage = () => {
  let navigate = useNavigate();
  // const st = useSelector((state) => state.rootReducer);
  return (
    <Grid container component="main" sx={styles.containerStyle}>
      <Grid item xs={12} md={12} lg={12} sx={styles.contentStyle}>
        <Box sx={styles.formCardContainerStyle}>
          <Typography style={{ fontSize: 40, my: 3, textAlign: 'left', color: '#003087' }}>
            Thank you for your request!
          </Typography>
          <Typography style={{ fontSize: 24 }}>
            It looks like a case already exists with that information
          </Typography>
          <Typography style={{ fontSize: 16, textAlign: 'left' }}>
            You don’t have permission to view the case at this time, but a request has been sent to
            the case coordinator to grant access, and you will receive an update once your request
            is reviewed.
          </Typography>
          <Box sx={{ m: 1, position: 'relative' }}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              sx={styles.formCardButtonStyle}
              onClick={() => navigate('/sop2web/home')}>
              Back to home
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

const styles = {
  containerStyle: {
    height: '93vh',
    backgroundColor: '#EDF3FC'
  },
  contentStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // minWidth: 600,
    border: 0,
    my: 8
  },
  formCardContainerStyle: {
    display: 'flex',
    border: 0,
    boxShadow: 1,
    borderColor: '#747678',
    flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'center',
    width: 450,
    padding: 4,
    gap: 2,
    background: '#FFFF'
  },
  formCardButtonStyle: {
    mt: 4,
    mb: 5,
    flex: 1,
    width: 350
  },
  formCardTitleStyle: {
    my: 4,
    mx: 4
    // alignItems: 'center',
    // justifyContent: 'center'
  }
};

export default RequestAccessMessage;
